import script from "./SkuMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkuMap.vue?vue&type=script&lang=ts&setup=true"

import "./SkuMap.vue?vue&type=style&index=0&id=571deaae&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571deaae"]])

export default __exports__